<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="bank-main">
    <div>
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="bank-main2">
      <div class="table-container" >
        <TableBox title="Bank" :tableData="bankList" :maxSelection="1" :selectedRow.sync="selectedBank" />
      </div>

      <PopupEntry v-if="showPopup" :show.sync="showPopup" :title="entryTitle" :createdBy="createdBy" :updatedBy="updatedBy" @save="saveBank"
          :messages="entryMessages" :errorMessages="Emessages" :successMessages="successMessages" :requiredError="requiredMessages" @requiredClicked="entryRequiredClicked" :viewMode="viewMode">
        <div class="bank-code">
          <Input placeholder="Bank Code" :isRequired="true" :inputValue.sync="bankCode" :isDisabled=" viewMode || entryTitle == 'Edit Bank'" :errorMessage.sync="bankCodeError" validator="masterfilecode,10" ref="bankcode" />
          <Input placeholder="Bank Name" :isRequired="true" :inputValue.sync="bankName" :isDisabled=" viewMode || entryTitle == 'Edit Bank'" :errorMessage.sync="bankNameError" ref="bankname" />
          <br>
        </div>

        <Tab :tabs="tabsItems" style="height: calc(100% - 29px)" :tabIndex.sync="currentTab">
          <!-- General Info -->
          <div slot="General Info">
            <div class="rowBox" style="margin: 0 0 10px 0;">
              <RadioButtonSet :buttons="bankTypeList" labelKey="label" :selected.sync="selectedBankType" title="Bank Type" :isRequired="true" :isDisabled="viewMode" :isHorizontal="true" :errorMessage.sync="bankTypeError" />
            </div>
            <Input placeholder="Bank Account No." :inputValue.sync="bankAccNo" :isDisabled="viewMode" :errorMessage.sync="bankAccNoError" ref="bankaccno" />
            <Input placeholder="Cheque No." :inputValue.sync="chequeNo" :isDisabled="viewMode" :errorMessage.sync="chequeNoError" ref="chequeno" />
            <InputQuery :isRequired="true" placeholder="GL Account No." :items="glAccNoList" :selectedObject.sync="selectedGlAccNo"
              itemKey="Acc No" descKey= "Description" :isDisabled="viewMode" :allowFreeText= "false" :errorMessage.sync="glAccNoError" ref="glaccno"/>
            <InputQuery placeholder="Bank Charges GL Account No." :items="bankChargesGLAccNoList" :selectedObject.sync="selectedBankChargesGLAccNo"
              itemKey="Acc No" descKey= "Description" :isDisabled="viewMode" :allowFreeText= "false" :errorMessage.sync="bankChargesGLAccNoError" ref="bankchargesglaccno" />
            <Input placeholder="Over Draft Amount" :inputValue.sync="overDraftAmount" :isDisabled="viewMode" validator="positiveDecimal,14,2" :errorMessage.sync="overDraftAmountError" ref="overdraftamount" @focusChanged="verifiedDecimals"/>
            <div class="flex-row">
              <Input placeholder="Up To Date Balance" :inputValue.sync="upToDateBalance" :isDisabled="viewMode" validator="positiveDecimal,14,2" :errorMessage.sync="upToDateBalanceError" ref="uptodatebalance" @focusChanged="verifiedDecimals"/>
              <Input placeholder="Up To Date Balance (Exp)" :inputValue.sync="upToDateBalanceExp" :isDisabled="viewMode" validator="positiveDecimal,14,2" :errorMessage.sync="upToDateBalanceExpError" ref="uptodatebalanceexp" @focusChanged="verifiedDecimals"/>
            </div>
            <RemarksBox title="Remarks" style="height: 100px" :text.sync="remarks" :isDisabled="viewMode" :maxLength=200 :errorMessage.sync="remarksError" ref="remarks" />
            <InputQuery :isRequired="true" placeholder="Currency Code" :items="currencyCodeList" :selectedObject.sync="selectedCurrencyCode"
              itemKey="Currency Code" descKey= "Description" :isDisabled="viewMode" :allowFreeText= "false" :errorMessage.sync="currencyCodeError" ref="currencycode"/>
            <Input placeholder="International Bank Account No." :inputValue.sync="internationalBankAccNo" :isDisabled="viewMode" :errorMessage.sync="internationalBankAccNoError" ref="internationalbankaccno" />
            <Input placeholder="Maker Name" :inputValue.sync="makerName" :isDisabled="viewMode" :errorMessage.sync="makerNameError" ref="makername" />
            <Input placeholder="Buyer Corporate ID" :inputValue.sync="buyerCorporateId" :isDisabled="viewMode" :errorMessage.sync="buyerCorporateIdError" ref="buyercorporateid" />
            <InputQuery placeholder="Swift Bank Code" :items="swiftBankCodeList" :selectedObject.sync="selectedSwiftBankCode"
              itemKey="Bank Swift Code" descKey= "Bank Name" :isDisabled="viewMode" :allowFreeText= "false" :errorMessage.sync="swiftBankCodeError" ref="swiftbankcode"/>
            <br>
            <br>	
          </div>

          <!-- Contact Details -->
          <div slot="Contact Details">
            <Input placeholder="Bank Officer" :inputValue.sync="bankOfficer" :isDisabled="viewMode" :errorMessage.sync="bankOfficerError" ref="bankofficer" />
            <br>
            <BoxContainer title="Address">
              <AddressFormV2 :address.sync="address" :addressErrors.sync="addressErrors" :viewMode="viewMode" :postcodes="postcodeList" :states="stateList" :countries="countryList" ref="addressForm" />
            <br>
            </BoxContainer>
            <br>
            <div class="flex-row">
              <Input placeholder="Phone Number (1)" :inputValue.sync="phoneNo1" :isDisabled="viewMode" validator="positiveInteger" :errorMessage.sync="phoneNo1Error" ref="phone1" />
              <Input placeholder="Phone Number (2)" :inputValue.sync="phoneNo2" :isDisabled="viewMode" validator="positiveInteger" :errorMessage.sync="phoneNo2Error" ref="phone2" />
            </div>
            <Input placeholder="Fax No. " :inputValue.sync="faxNo" :isDisabled="viewMode" :errorMessage.sync="faxNoError" ref="faxno" />
            <Input placeholder="Email" :inputValue.sync="email" :isDisabled="viewMode" :errorMessage.sync="emailError" ref="email" />

          </div>

        </Tab>
      </PopupEntry>
    
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
      showPopup: false,
      Emessages: [],
      successMessages: [],
      requiredMessages: [],
      entryTitle: '',
      updatedBy: '',
      createdBy: '',
      
      saveAction: '',

      menu: [
        { title: 'New Bank', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', enabled: true , key: 'MnuNew' , visible: true},
        { title: 'Edit Bank', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', enabled: true , key: 'MnuEdit' , visible: true },
        { title: 'Delete Bank', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',  enabled: true , key: 'MnuDelete' , visible: false},
        { title: 'View Bank', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',  enabled: true , key: 'MnuQuery' , visible: true}
      ],
      tabsItems: [
        { title: 'General Info' },
        { title: 'Contact Details' },
      ],
      currentTab: 0,

      errorMapping: [
        { key: 'bankcode', tab: -1 },
        { key: 'bankname', tab: -1 },

        { key: 'banktype', tab: 0 },
        { key: 'bankaccno', tab: 0 },
        { key: 'chequeno', tab: 0 },
        { key: 'glaccno', tab: 0 },
        { key: 'bankchargesglaccno', tab: 0 },
        { key: 'overdraftamount', tab: 0 },
        { key: 'uptodatebalance', tab: 0 },
        { key: 'uptodatebalanceexp', tab: 0 },
        { key: 'remarks', tab: 0 },
        { key: 'currencycode', tab: 0 },
        { key: 'internationalbankaccno', tab: 0 },
        { key: 'makername', tab: 0 },
        { key: 'buyercorporateid', tab: 0 },
        { key: 'swiftbankcode', tab: 0 },

        { key: 'bankofficer', tab: 1 },
        { key: 'addressLine1', tab: 1 },
        { key: 'addressLine2', tab: 1 },
        { key: 'addressLine3', tab: 1 },
        { key: 'addressLine4', tab: 1 },
        { key: 'postcode', tab: 1 },
        { key: 'city', tab: 1 },
        { key: 'state', tab: 1 },
        { key: 'country', tab: 1 },
        { key: 'phone1', tab: 1 },
        { key: 'phone2', tab: 1 },
        { key: 'faxno', tab: 1 },
        { key: 'email', tab: 1 },
      ],

      bankTypeList: [
        { label: 'Cheque Bank (CH) ', keyValue: 'CH' },
        { label: 'Petty Cash (CS) ', keyValue: 'CS' },
        { label: 'Pre-Paid (PR) ', keyValue: 'PR' },
        { label: 'Post-Paid (PP) ', keyValue: 'PP' },
      ],
      selectedBankType: null,

      bankList: [],
      selectedBank: [],
      selectedGlAccNo:[],
      selectedBankChargesGLAccNo:[],
      selectedCurrencyCode:[],
      selectedSwiftBankCode:[],

      glAccNoList: [],
      bankChargesGLAccNoList: [],
      currencyCodeList: [],
      swiftBankCodeList: [],
      postcodeList: [],
      stateList: [],
      countryList: [],

      saveAction:'',
      viewMode: false,
      showUploadPopup: true,

      //#region General Info Data
      bankCode:'',
      bankName:'',
      bankAccNo:'',
      chequeNo:'',
      overDraftAmount:'',
      upToDateBalance:'',
      upToDateBalanceExp:'',
      remarks:'',
      internationalBankAccNo:'',
      makerName:'',
      buyerCorporateId:'',

      //error message
      bankCodeError:'',
      bankNameError:'',
      bankTypeError:'',
      bankAccNoError:'',
      chequeNoError:'',
      glAccNoError:'',
      bankChargesGLAccNoError:'',
      overDraftAmountError:'',
      upToDateBalanceError:'',
      upToDateBalanceExpError:'',
      remarksError:'',
      currencyCodeError:'',
      internationalBankAccNoError:'',
      makerNameError:'',
      buyerCorporateIdError:'',
      swiftBankCodeError:'',
      //#endregion
    
      //#region Contact Details
      bankOfficer:'',
      address: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      phoneNo1:'',
      phoneNo2:'',
      faxNo:'',
      email:'',
        
      //error message
      bankOfficerError:'',
      addressErrors: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      phoneNo1Error:'',
      phoneNo2Error:'',
      faxNoError:'',
      emailError:'',
      //#endregion

    };
  },
  props: {
  },
  methods: {
    //Button Actions
    menuClicked: async function(e) {
      this.clearEntryMessages();

      switch (e.title) {
        case 'New Bank':
          this.$fullscreenLoading("Please Wait");
          this.clearForm();
          this.clearErrorMsgs();
          this.entryTitle = 'New Bank ';
          this.showPopup = true;
          this.saveAction = 'N';
          this.$fullscreenLoading();
          break;
        case 'Edit Bank':
          if (!this.selectedBank[0]) {
            this.$showAlert('error', 'No Bank Selected', `Please select a record to edit`);
          } 
          else {
            this.$fullscreenLoading("Please Wait");
            this.showPopup = true;
            this.entryTitle = 'Edit Bank';
            this.clearErrorMsgs();
            this.populateBankDetails();
            this.saveAction = 'E'
            await this.getBankDetails(this.selectedBank[0]['BankCode']);
            this.$fullscreenLoading();
          }
          break;
        case 'Delete Bank':
          if (this.selectedBank.length == 0) {
            await this.$showAlert('error', 'No Bank Selected', 'Please select a record to delete');
          } 
          else {
            let isDelete = await this.$showAlert('warning', 'Delete Bank', `Are you sure want to Delete Bank ${this.selectedBank[0]['BankCode']}?`, [
              { text: 'Delete', color: 'red', textColor: 'white' },
              { text: 'Cancel', color: 'gray', textColor: 'white' }
            ]);
            
            if (isDelete == 'Delete') { 
              let result = await this.$apiCallV2('/Bank/SaveBank', {
                action: 'D',
                bank_code: this.selectedBank[0]['BankCode'],
              });
              if(result[0]['Results'] == 0) {
                this.$showAlert('success', 'Bank Deleted', `Successfully deleted ${this.bankCode}!`);
              }
              this.populateBankDetails();
              this.$nextTick(async () => await this.getBankList());
            }
          }
          this.selectedBank = [];
          break;
        case 'View Bank':
          if (!this.selectedBank[0]) {
            this.$showAlert('error', 'No Bank Selected', `Please select a record to view`);
          } 
          else {
            this.showPopup = true;
            this.entryTitle = 'View Bank';
            this.clearErrorMsgs();
            this.populateBankDetails();
            this.viewMode = true;
            await this.getBankDetails(this.selectedBank[0]['BankCode']);
          }
          break;
      }
    },

    getBankList: async function() {
      this.bankList = [];
      this.bankList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BANK' });
    },

    getGLAndBankChargesAccNoList: async function() {
      const response = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'GLACCOUNT' });

      this.glAccNoList = [];
      this.bankChargesGLAccNoList = [];

      this.glAccNoList = response;
      this.bankChargesGLAccNoList = response;
    },

    getCurrencyCodeList: async function() {
      this.currencyCodeList = [];
      this.currencyCodeList= await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CURRENCY' });
    },

    getSwiftBankCodeList: async function() {
      this.swiftBankCodeList = [];
      this.swiftBankCodeList= await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BANKSWIFTCODE' });
    },

    getPostcodeList: async function() {
      this.postcodeList = [];
      this.postcodeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'postcode' });
    },

    getStateList: async function() {
      this.stateList = [];
      this.stateList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'state' });
    },

    getCountryList: async function() {
      this.countryList = [];
      this.countryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' });
    },

    populateBankDetails: function () {
      this.clearForm();
      if (this.selectedBank[0]) {
        this.bankCode = this.selectedBank[0]['BankCode'];
        this.bankName = this.selectedBank[0]['BankName'];
      }
    },

    checkFields: function() {
      this.clearEntryMessages();
      this.entryRequired = [];

      if (!this.bankCode) {
        this.bankCodeError = 'Bank Code is required!';
        this.requiredMessages.push({ Key: 'bankcode', Value: 'Bank Code is required!' })
      }else if(this.bankCode.length > 10) {
        this.bankCodeError = 'Bank Code cannot exceed 10 characters!';
        this.requiredMessages.push({ Key: 'bankcode', Value: 'Bank Code cannot exceed 10 characters!' })	
      }
      if (!this.bankName) {
        this.bankNameError = 'Bank Name is required!';
        this.requiredMessages.push({ Key: 'bankname', Value: 'Bank Name is required!' })
      }else if(this.bankName.length > 200) {
        this.bankNameError = 'Bank Name cannot exceed 200 characters!';
        this.requiredMessages.push({ Key: 'bankname', Value: 'Bank Name cannot exceed 200 characters!' })
      }
      if(!this.selectedBankType) {
        this.bankTypeError = 'Bank Type is required!';
        this.requiredMessages.push({ key: 'banktype', value: 'Bank Type is required!' });
      }
      if (this.bankAccNo.length > 20) {
        this.bankAccNoError = 'Bank Account Number cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'bankaccno', Value: 'Bank Account Number cannot exceed 20 characters!' })
      }
      if (this.chequeNo.length > 25) {
        this.chequeNoError = 'Cheque Number cannot exceed 25 characters!';
        this.requiredMessages.push({ Key: 'chequeno', Value: 'Cheque Number cannot exceed 25 characters!' })
      }
      if (!this.selectedGlAccNo) {
        this.glAccNoError = 'GL Account Number is required!';
        this.requiredMessages.push({ Key: 'glaccno', Value: 'GL Account Number is required!' })
      }else if(this.selectedGlAccNo['Acc No']?.length > 20) {
        this.glAccNoError = 'GL Account Number cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'glaccno', Value: 'GL Account Number cannot exceed 20 characters!' })	
      }
      if (this.selectedBankChargesGLAccNo?.['Acc No']?.length > 20) {
        this.bankChargesGLAccNoError = 'Bank Charges GL Account Number cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'bankchargesglaccno', Value: 'Bank Charges GL Account Number cannot exceed 20 characters!' })
      }
      // Validate overdraftamount
      if (!this.isValidDecimal(this.overDraftAmount, 4)) {
        this.overDraftAmountError = 'Invalid Over Draft Amount!';
        this.requiredMessages.push({ Key: 'overdraftamount', Value: 'Invalid Over Draft Amount!' });
      }
      // Validate uptodatebalance
      if (!this.isValidDecimal(this.upToDateBalance, 4)) {
        this.upToDateBalanceError = 'Invalid Up To Date Balance!';
        this.requiredMessages.push({ Key: 'uptodatebalance', Value: 'Invalid Up To Date Balance!' });
      }
      // Validate uptodatebalanceexp
      if (!this.isValidDecimal(this.upToDateBalanceExp, 4)) {
        this.upToDateBalanceExpError = 'Invalid Up To Date Balance (Exp)!';
        this.requiredMessages.push({ Key: 'uptodatebalanceexp', Value: 'Invalid Up To Date Balance (Exp)!' });
      }
      if (this.remarks.length > 200) {
        this.remarksError = 'Default Remarks cannot exceed 200 characters!'
        this.requiredMessages.push({ Key: 'remarks', Value: 'Default Remarks cannot exceed 200 characters!' })
      }
      if (!this.selectedCurrencyCode) {
        this.currencyCodeError = 'Currency Code is required!';
        this.requiredMessages.push({ Key: 'currencycode', Value: 'Currency Code is required!' })
      }else if(this.selectedCurrencyCode['Currency Code']?.length > 10) {
        this.currencyCodeError = 'Currency Code cannot exceed 10 characters!';
        this.requiredMessages.push({ Key: 'currencycode', Value: 'Currency Code cannot exceed 10 characters!' })	
      }
      if (this.internationalBankAccNo.length > 35) {
        this.internationalBankAccNoError = 'International Bank Account Number cannot exceed 35 characters!';
        this.requiredMessages.push({ Key: 'internationalbankaccno', Value: 'International Bank Account Number cannot exceed 35 characters!' })
      }
      if (this.makerName.length > 35) {
        this.makerNameError = 'Maker Name cannot exceed 35 characters!';
        this.requiredMessages.push({ Key: 'makername', Value: 'Maker Name cannot exceed 35 characters!' })
      }
      if (this.buyerCorporateId.length > 20) {
        this.buyerCorporateIdError = 'Buyer Corporate Id cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'buyercorporateid', Value: 'Buyer Corporate Id cannot exceed 20 characters!' })
      }
      if (this.selectedSwiftBankCode?.['Bank Swift Code']?.length > 25) {
        this.swiftBankCodeError = 'Swift Bank Code cannot exceed 25 characters!';
        this.requiredMessages.push({ Key: 'swiftbankcode', Value: 'Swift Bank Code cannot exceed 25 characters!' })
      }
      if (this.bankOfficer.length > 100) {
        this.bankOfficerError = 'Bank Officer cannot exceed 100 characters!'
        this.requiredMessages.push({ Key: 'bankofficer', Value: 'Bank Officer cannot exceed 100 characters!' })
      }
      if (this.address.addressLine1.length > 40) {
          this.addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
          this.requiredMessages.push({ Key: 'addressLine1', Value: 'Address Line 1 cannot exceed 40 characters!' })
      }
      if (this.address.addressLine2.length > 40) {
        this.addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine2', Value: 'Address Line 2 cannot exceed 40 characters!' })
      }
      if (this.address.addressLine3.length > 40) {
        this.addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine3', Value: 'Address Line 3 cannot exceed 40 characters!' })
      }
      if (this.address.addressLine4.length > 40) {
        this.addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine4', Value: 'Address Line 4 cannot exceed 40 characters!' })
      }
      if (this.address.city.length > 30) {
        this.addressErrors.city = 'City cannot exceed 30 characters!';
        this.requiredMessages.push({ Key: 'city', Value: 'City cannot exceed 30 characters!' })
      }
      if (this.phoneNo1.length > 20) {
        this.phoneNo1Error = 'Phone No. cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'phone1', Value: 'Phone No. cannot exceed 20 characters!' })
      }
      if (this.phoneNo2.length > 20) {
        this.phoneNo2Error = 'Phone No. cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'phone2', Value: 'Phone No. cannot exceed 20 characters!' })
      }
      if (this.faxNo.length > 20) {
        this.faxNoError = 'Fax No. cannot exceed 20 characters!';
        this.requiredMessages.push({ Key: 'faxno', Value: 'Fax No. cannot exceed 20 characters!' })
      }
      if (this.email.length > 40) {
        this.emailError = 'Email cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'email', Value: 'Email cannot exceed 40 characters!' })
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.email && !emailRegex.test(this.email)) {
        this.emailError = 'Invalid email format!';
        this.requiredMessages.push({ Key: 'email', Value: 'Invalid email format!' });
      }
      return this.requiredMessages.length > 0;
    },

    isValidDecimal(value, maxDecimalPlaces) {
      const stringValue = String(value);
      const parts = stringValue.split('.');

      if (parts.length === 2 && parts[1].length > maxDecimalPlaces) {
        return false;
      }
      return true;
    },

    saveBank: async function() {
      this.$fullscreenLoading("Saving");
      this.clearEntryMessages();
      this.$fullscreenLoading();

      let invalid = this.checkFields();
      if (!invalid){
        var dataToPost = {

          createdBy: this.createdBy,
          updatedBy: this.updatedBy,
          action: this.saveAction,

          //#region Details Info
          selectedBank: this.selectedBank,
          bank_code: this.bankCode,
          bank_name: this.bankName,
          banktype: this.selectedBankType?.keyValue ?? '',
          bankaccno: this.bankAccNo,
          chqno: this.chequeNo,
          accno: this.selectedGlAccNo?.["Acc No"] ?? '',
          bankchrgac: this.selectedBankChargesGLAccNo?.["Acc No"] ?? '',
          bankodlimit: this.overDraftAmount,
          bank_balance: this.upToDateBalance,
          bank_balancedepot: this.upToDateBalanceExp,
          bankremarks: this.remarks,
          bankcurrency: this.selectedCurrencyCode?.["Currency Code"] ?? '',
          buyeriban: this.internationalBankAccNo,
          makername: this.makerName,
          buyerbankid: this.buyerCorporateId,
          swiftcode: this.selectedSwiftBankCode?.["Bank Swift Code"] ?? '',
          
          //#region Contact Details
          bank_officer: this.bankOfficer,
          bank_address1: this.address['addressLine1'],
          bank_address2: this.address['addressLine2'],
          bank_address3: this.address['addressLine3'],
          bank_address4: this.address['addressLine4'],
          bank_postcode: this.address['postcode'],
          city: this.address['city'],
          state: this.address['state'],
          country: this.address['country'],
          bank_telno1: this.phoneNo1,
          bank_telno2: this.phoneNo2,
          bank_faxno: this.faxNo,
          bank_email: this.email,
        }
        
        this.$fullscreenLoading("Saving Bank Details");
        var postUpdate = await this.$apiCallV2('/Bank/SaveBank', dataToPost);
        this.$fullscreenLoading();

        if (postUpdate[0]['Results'] >= 1) {
          this.Emessages.push(postUpdate[0].ErrMsg);
        } 
        else {
          this.viewMode = true;
          this.successMessages.push('Successfully saved Bank Details!'); 
          this.showPopup = true;
          this.entryTitle = 'View Bank';
          this.getBankList();
        }
      }
    },

    getBankDetails: async function(record) {
      this.$fullscreenLoading("Getting Bank Details");
      let details = (await this.$apiCallV2(`/Master/GetDetailsMaster`, { module: "Master", masterfile: 'BANK', recordid: record }))['Bank'];
      this.$fullscreenLoading();

      if (!this.address) {
        this.address = {
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          postcode: '',
          city: '',
          state: '',
          country: '',
        };
      }

      //#region Details Info
      this.bankCode = details['Bank_code'];
      this.bankName = details['Bank_name'];
      this.selectedBankType = this.bankTypeList.getSelected(details['BankType'], 'keyValue');
      this.bankAccNo = details['BankAccNo'],
      this.chequeNo = details['Chq_no'],
      this.selectedGlAccNo = this.glAccNoList.getSelected(details['Accno'], 'Acc No');
      this.selectedBankChargesGLAccNo = this.bankChargesGLAccNoList.getSelected(details['BankChrgAc'],'Acc No');
      this.overDraftAmount = details['BankODLimit'],
      this.upToDateBalance = details['Bank_Balance'],
      this.upToDateBalanceExp = details['Bank_BalanceDepot'],
      this.remarks = details['BankRemarks'],
      this.selectedCurrencyCode = this.currencyCodeList.getSelected(details['BankCurrency'],'Currency Code');
      this.internationalBankAccNo = details['BuyerIban'],
      this.makerName = details['MakerName'],
      this.buyerCorporateId = details['BuyerBankID'],
      this.selectedSwiftBankCode = this.swiftBankCodeList.getSelected(details['SwiftCode'],'Bank Swift Code');
      //#end region

      //#region Contact Details
      this.bankOfficer = details['Bank_officer'],
      this.address['addressLine1'] = details['Bank_Address1'],
      this.address['addressLine2'] = details['Bank_Address2'],
      this.address['addressLine3'] = details['Bank_Address3'],
      this.address['addressLine4'] = details['Bank_Address4'],
      this.address['postcode'] = details['Bank_PostCode'],
      this.address['city'] = details['City'],
      this.address['state'] = details['State'],
      this.address['country'] = details['Country'],
      this.phoneNo1 = details['Bank_TelNo1'],
      this.phoneNo2 = details['Bank_TelNo2'],
      this.faxNo = details['Bank_FaxNo'],
      this.email = details['Bank_email'],
      //#end region

      this.createdBy = `${details['UserCreated']} ${new Date(details['TimeCreated']) ? this.$dateTime.getDateTime(new Date(details['TimeCreated']), 'dd/MM/yyyy HH:mm') : ''}`;
      this.updatedBy = `${details['UserID']} ${new Date(details['DateUpdate']) ? this.$dateTime.getDateTime(new Date(details['DateUpdate']), 'dd/MM/yyyy HH:mm') : ''}`;
    },

    clearEntryMessages: function() {
      this.requiredMessages = [];
      this.successMessages = [];
      this.entryMessages = [];
      this.Emessages = [];
    },

    clearErrorMsgs: function() {
      this.bankCodeError = "";
      this.bankNameError = "";
      this.bankTypeError = "";
      this.bankAccNoError = "";
      this.chequeNoError = "";
      this.glAccNoError = "";
      this.bankChargesGLAccNoError = "";
      this.overDraftAmountError = "";
      this.upToDateBalanceError = "";
      this.upToDateBalanceExpError = "";
      this.remarksError = "";
      this.currencyCodeError = "";
      this.internationalBankAccNoError = "";
      this.makerNameError = "";
      this.buyerCorporateIdError = "";
      this.swiftBankCodeError = "";
      this.bankOfficerError = "";
      this.addressErrors.addressLine1 = "";
      this.addressErrors.addressLine2 = "";
      this.addressErrors.addressLine3 = "";
      this.addressErrors.addressLine4 = "";
      this.addressErrors.city= "";
      this.phoneNo1Error = "";
      this.phoneNo2Error = "";
      this.faxNoError = "";
      this.emailError = "";
    },

    clearForm: function() {
      this.clearEntryMessages();
      this.currentTab = 0;
      this.viewMode = false;
      this.updatedBy = '';
      this.createdBy = '';
      this.saveAction = '';

      //#region Details Info
      this.bankCode = '';
      this.bankName  = '';
      this.selectedBankType = null;
      this.bankAccNo = '';
      this.chequeNo = '';
      this.selectedGlAccNo = null;
      this.selectedBankChargesGLAccNo = null;
      this.overDraftAmount = '';
      this.upToDateBalance = '';
      this.upToDateBalanceExp = '';
      this.remarks = '';
      this.selectedCurrencyCode = null;
      this.internationalBankAccNo = '';
      this.makerName = '';
      this.buyerCorporateId = '';
      this.selectedSwiftBankCode = null;
      //#end region

      //#region Contact Details
      this.bankOfficer = '';
      this.address['addressLine1'] = '';
      this.address['addressLine2'] = '';
      this.address['addressLine3'] = '';
      this.address['addressLine4'] = '';
      this.address['postcode'] = '';
      this.address['city'] = '';
      this.address['state'] = '';
      this.address['country'] = '';
      this.phoneNo1 = '';
      this.phoneNo2 = '';
      this.faxNo = '';
      this.email = '';
      //#end region
    },

    entryRequiredClicked: function(item) {
      let errorTabs = this.errorMapping.find(e => e['key'] == item);

      if (this.currentTab != errorTabs['tab'] && errorTabs['tab'] >= 0) {
        this.currentTab = errorTabs['tab'];
      }

      this.$nextTick(() => {
        switch (errorTabs['key']) {
          case "addressLine1":
            this.$refs["addressForm"].setFocus("address1");
            break;

          case "addressLine2":
            this.$refs["addressForm"].setFocus("address2");
            break;

          case "addressLine3":
            this.$refs["addressForm"].setFocus("address3");
            break;
            
          case "addressLine4":
            this.$refs["addressForm"].setFocus("address4");
            break;

          case "city":
            this.$refs["addressForm"].setFocus("city");
            break;

          default:
            this.$refs[item]?.setFocus?.();
            break;
        }	
      });
    },
    verifiedDecimals: function(){
      if (this.overDraftAmount){
        this.overDraftAmount = parseFloat(this.overDraftAmount).toFixed(2)
      } 
      if (this.upToDateBalance){
        this.upToDateBalance = parseFloat(this.upToDateBalance).toFixed(2)
      } 
      if (this.upToDateBalanceExp){
        this.upToDateBalanceExp = parseFloat(this.upToDateBalanceExp).toFixed(2)
      } 
    }
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Bank') {
        x.data.forEach(k => {
          //key in menu same as control value from api
          let selectedMenu = this.menu.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        })
      }
    })

    this.$fullscreenLoading("Getting Banks");
    await this.getBankList();

    this.$fullscreenLoading("Getting GL Accounts");
    await this.getGLAndBankChargesAccNoList();

    this.$fullscreenLoading("Getting Currencies");
    await this.getCurrencyCodeList();

    this.$fullscreenLoading("Getting Bank Swift Codes");
    await this.getSwiftBankCodeList();

    this.$fullscreenLoading("Getting Postcodes");
    await this.getPostcodeList();

    this.$fullscreenLoading("Getting States");
    await this.getStateList();

    this.$fullscreenLoading("Getting Countries");
    await this.getCountryList();

    this.$fullscreenLoading();

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Bank Details' });
    }
  },
  watch: {
    showPopup: async function(val) {
      if (!val && this.$route.query['new'] && !this.viewMode) { // When the cancel is click but is not saved (for query new=1)
        let closeWindow = await this.$showAlert('warning', 'Cancelling Bank Files Creation', `You have not created an Bank profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`, [
          { "text": "Continue Creating" },
          { "text": "Cancel Creating", "color": "red", "textColor": "white" }
        ]);

        if (closeWindow == 'Cancel Creating') { // If user choose to cancel the creating process, it will close the tab
          window.close();
        } 
        else {
          this.showPopup = true;
        }
      } 
      else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
      if (!val) {
        this.clearForm();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.bank-main {
  width: 100%;
  height: 100%;	
  padding: 10px 45px;
  overflow: hidden;
  display: flex;
  font-size: 12px;
}
.bank-main2{
  display: flex;
  flex-direction: column;
  // width: auto;
  // height: auto;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-left: 5px;

  > .map-container, > .table-container {
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    margin-top: 5px;
    transition: 0.3s;
  }
  > #upload-popup{
    position: absolute;
    height: 85vh;
    width: 85vw;
    background-color: white;
    z-index: 100;
    top: 45vh;
    left: 50vw;
    transform: translate(-50%,-50%);
    border-radius: 10px;
    padding: 20px;
    border: 3px solid grey;
    > .close-button {
      position: absolute;
      right: 30px;
    }
    > .submit-button {
      position: absolute;
      right: 30px;
      bottom: 20px;
    }
    > .legend-container {
      position: absolute;
      bottom: 20px;
      border: 1px solid grey;
      border-radius: 5px;
      padding: 10px;
    }

    > .match-container {
      display: flex;

      > .no-matches-found, .match-found {
        width: 100%;
        
        > .title{
          font-size: 1.25em;
          font-weight: bold;
          text-align: center;
        }
        > .title-container {
          display: flex;
          border-bottom: 1px solid grey;
          > &:first-child{
            margin-right: 10px;
          }
          > .title {
            font-weight: bold;
            width: 100%;
            text-align: center;
          }
        }
        > .list-container {
          height: 55vh;
          overflow: auto;
          // background-color: green;
          > .list-item {
            display: flex;
            min-height: 4em;
            align-items: center;
            padding: 20px;
            &:nth-child(even){
              background-color: rgb(244, 244, 244);
            }
            > div {
              width: 100%;
            }
            > .name{
              // text-align: right;
              margin-right: 10px;
            }
            > .match {
              display: flex;

            }
          }

        }
      }
      > .no-matches-found{
        border-right: 1px solid grey;
      }
    }
    
  }
}
.tabBox {
  width: 100%;
  height: 100%;
  position: relative;
}
.tabtab {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 38px;
}
.bank-code {
  align-items: center;
}
.flex-row {
  display: flex;
  align-items: center;

  > * {
    width: 100%;
  }

  > :not(:first-child) {
    margin-left: 5px;
  }
}
.rowBox {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: 0.3s;

  > .rowTitle {
    white-space: nowrap; 
    margin: 0 20px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .rowReq {
      height: 100%;
      margin: 0 10px 0 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      color: #ff000088;
    }
  }
}
</style>